import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Card, Col, Row } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BASE_URL } from '../../../services/Api';
import { authHeader } from '../../../services/auth-header';
import SOMIConvert from '../AraiManufacturing/Convert';
import SOPIConvert from '../PumpSpareInternational/Convert';

function SoToSalesConvert() {
  const navigate = useNavigate();
  const { pointindex, id } = useParams();
  const [salestype, setsalestype] = useState('');
  const [salescategory, setsalescategory] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}salesOrder/findById/${id}`, {
          headers: authHeader(),
        });
        setsalestype(response.data.salesordertype);
        setsalescategory(response.data.salesordercategory);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [id]);

  const renderPageDisplay = () => {
    if (salestype === 'Pump Spare') {
      if (salescategory === 'International') {
        return <SOPIConvert /* pass props if needed */ />;
      }
    } else if (salestype === 'Manufacturing') {
      if (salescategory === 'International') {
        return <SOMIConvert /* pass props if needed */ />;
      }
    }
    return null;
  };

  // Delete handler not enabled, but here if you want to use later
  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.delete(`${BASE_URL}sales/delete/${id}`, {
          headers: authHeader(),
        });
        if (response.data.length === 0) {
          Swal.fire('Warning', 'PO is present in another module. Delete operation has been cancelled.', 'warning');
        } else {
          navigate(`/salesindex/${pointindex}`);
          Swal.fire('Deleted!', 'Deleted successfully.', 'success');
        }
      } catch (error) {
        Swal.fire('Error', error.response?.data || 'An error occurred', 'error');
      }
    }
  };

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6> SALES ORDER TO SALES INVOICE </h6>
          <div className="view-buttons">
            {/* Uncomment if needed */}
            {/* <button className="button-70" onClick={() => handleDelete(id)}>DELETE</button> */}
            {/* <Link to={`/salesEdit/${id}/${pointindex}`}>
              <button className="button-70">EDIT</button>
            </Link> */}
            <Link to={`/soindex/1`}>
              <button className="button-70">BACK</button>
            </Link>
          </div>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select Product Type:</Form.Label>
                <Form.Select disabled value={salestype} onChange={(e) => setsalestype(e.target.value)}>
                  <option value="">--Please choose an option--</option>
                  <option value="Pump Spare">Pump Spare</option>
                  <option value="Manufacturing">Manufacturing</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select Product Category:</Form.Label>
                <Form.Select disabled value={salescategory} onChange={(e) => setsalescategory(e.target.value)}>
                  <option value="">--Please choose an option--</option>
                  <option value="Domestic">Domestic</option>
                  <option value="International">International</option>
                </Form.Select>
              </Form.Group>
            </Col>
            {renderPageDisplay()}
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
}

export default SoToSalesConvert;
